import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect } from "react";
import { addCaseCreation } from "services/caseServices";
import { CaseCreation, InvestigationFile } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

interface Props {
  file?: InvestigationFile;
  investigationFiles: InvestigationFile[];
  caseData?: CaseCreation;
  onCancel: () => void;
  isOpen: boolean;
}

const defaultValue: CaseCreation = {
  id: 0,
  prosecutor_registration_number: "",
  // date_sent_to_prosecutor: new Date(),
  // estimated_day_to_finish: new Date(),
  status: "Pending",
  incident_registration_no: "",
  crime_refernce_number: "",
  relation_type: "original",
  investigation_files: [],
  is_RTD: false,
};

const RequestInstituteOfCharge: React.FC<Props> = ({
  onCancel,
  file,
  investigationFiles,
  isOpen,
  caseData,
}) => {
  const { loginData } = useAuth();
  console.log(loginData);
  const { showTooltip } = useTooltip();
  const [formState, setFormState] = React.useState<CaseCreation>(defaultValue);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (caseData) {
      setFormState(caseData);
    } else if (file) {
      setFormState({
        ...defaultValue,
        id: file.uu_id,
        prosecutor_registration_number: file?.prosecutor_registration_number,
        date_sent_to_prosecutor: file?.prosecutor_assignment_date,
        incident_registration_no: file.incident_registration_number,
        crime_refernce_number: file.crime_reference_number,
        crime_type: file.crime_type || undefined,
        investigation_files: file.id !== undefined ? [file.id] : [],
      });
    }
  }, [file, caseData]);

  if (!isOpen) return null;

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onCancel();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormState((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormState((prevState: any) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">
          Institute of Charge
        </h2>
        <div className="flex flex-col mt-4">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Select Investigation Files
          </label>
          <select
            className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300 h-32"
            name="investigation_files"
            // value={
            //   Array.isArray(formState?.investigation_files)
            //     ? formState.investigation_files.map((file: any) =>
            //         typeof file === "object"
            //           ? String(file.uu_id ?? file.id)
            //           : String(file)
            //       )
            //     : []
            // }
            value={(formState?.investigation_files ?? []).map(String)}
            onChange={(e) => {
              const selectedIds = Array.from(e.target.selectedOptions).map(
                (option) => option.value,
              );
              console.log(selectedIds);
              setFormState((prev) => ({
                ...prev,
                investigation_files: selectedIds.map((id) => id),
              }));
            }}
            multiple
          >
            {Array.isArray(investigationFiles) &&
              investigationFiles.map((f) => (
                <option key={f?.id} value={f?.id} selected={f?.id === file?.id}>
                  {f.crime_reference_number}
                </option>
              ))}
          </select>
        </div>

        <div className="flex flex-col mt-4 w-full">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Prosecution Registration Number
          </label>
          <input
            className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
            name="prosecutor_registration_number"
            placeholder="Enter Prosecution Case Number"
            value={
              formState?.prosecutor_registration_number
                ? formState?.prosecutor_registration_number
                : ""
            }
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col mt-4 w-full">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2 flex items-center gap-2">
            <input
              type="checkbox"
              name="is_RTD"
              checked={!!formState.is_RTD}
              onChange={handleCheckboxChange}
              className="mr-2"
            />
            Is RTD
          </label>
        </div>
        <div className="flex flex-row gap-5">
          <div className="flex flex-col mt-4 w-full">
            <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
              Date Sent to Prosecutor
            </label>
            <input
              type="date"
              className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
              name="date_sent_to_prosecutor"
              value={
                formState?.date_sent_to_prosecutor
                  ? new Date(formState.date_sent_to_prosecutor)
                      .toISOString()
                      .split("T")[0]
                  : ""
              }
              readOnly={!!formState.date_sent_to_prosecutor}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col mt-4 w-full">
            <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
              Estimated day to Finish
            </label>
            <input
              type="date"
              className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
              name="estimated_day_to_finish"
              value={
                formState?.estimated_day_to_finish
                  ? new Date(formState.estimated_day_to_finish)
                      .toISOString()
                      .split("T")[0]
                  : ""
              }
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="mt-4 flex justify-between gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              addCaseCreation({
                ...formState,
                assigned_prosecutor_name: loginData?.full_name || "",
                assigned_prosecutor_userid: loginData?.user_id || "",
                admin_unit_id: loginData?.admin_unit || "",
                org_id: loginData?.org_unit || "",
                relation_type:
                  (formState?.investigation_files?.length ?? 0) > 1
                    ? "merged"
                    : "original",
              })
                .then(() => {
                  setLoading(false);
                  showTooltip("Case Created Successfully!", "success");
                  onCancel();
                })
                .catch((error) => {
                  setLoading(false);
                  showTooltip(
                    error?.response?.data?.detail ||
                      errorHandlerOnForm(error) ||
                      errorHandler(error) ||
                      "Something went wrong. Please try again.",
                    "error",
                  );
                });
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                Loading...
              </div>
            ) : (
              "Create"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestInstituteOfCharge;
